<template>
    <svg width="14" height="25" viewBox="0 0 14 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.24075 9.52651H13.6647V13.9505H9.24075V24.25H4.81678V13.9505H0.392822V9.52651H4.81678V7.64863C4.81678 6.7068 4.96366 5.7506 5.25888 4.78285C5.55411 3.81509 5.9602 3.04898 6.48008 2.48159C7.56448 1.28054 8.93399 0.678589 10.5858 0.678589H13.6647V5.10255H10.5858C10.2085 5.10255 9.88877 5.22639 9.62955 5.4741C9.37034 5.72182 9.24072 6.03285 9.24072 6.41016V9.52651H9.24075Z" fill="currentcolor"/>
    </svg>
</template>

<script>
export default {
	name: "Facebook"
};
</script>

<style scoped>

</style>
